<template>
  <div class="discovery-book-view">
    {{ data }}
  </div>
</template>

<script>

export default {
  name: 'BookView',
  components: {
  },
  props: {
    cn: Number,
  },
  data() {
    return {
      item: {},
      data: {},
    };
  },
  mounted() {
    this.JsPAPI.api.bibGet(this.cn).then((r) => {
      Discovery.log('Received item data');
      this.item = r.data;
      this.data = this.JsPAPI.util.bibParser(r.data);
    });
  },
  methods: {
  },
};
</script>

<style scoped lang="less">

</style>
